import PropTypes from "prop-types";

import { Box, Button, Tooltip } from "@mui/material";

export const ResponsiveToolbarButton = ({ label, sx, ...buttonProps }) => (
  <Tooltip title={label}>
    <Button
      {...buttonProps}
      sx={{
        minWidth: { xs: 0, sm: 64 },
        "& .MuiButton-startIcon": {
          mr: { xs: 0, sm: 1 },
          ml: { xs: 0, sm: -0.5 },
        },
        ...sx,
      }}
    >
      <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
        {label}
      </Box>
    </Button>
  </Tooltip>
);

ResponsiveToolbarButton.propTypes = {
  label: PropTypes.string.isRequired,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};
